import { LitElement, html, nothing } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { loadingIconStyles } from "js/sharedStyles/loadingIcon.js";

class BCLoadingIcon extends LitElement {
  static get properties() {
    return {
      loadingTitle: { type: String, attribute: "data-loading-title" },
      inline: {
        type: Boolean,
        reflect: true,
        default: false,
        attribute: "data-inline",
      },
    };
  }

  static styles = [loadingIconStyles];

  render() {
    const classes = { "bc-loading": true, "bc-loading--inline": this.inline };

    return html`<div class=${classMap(classes)}>
      ${this.loadingTitle ? html`<h2>${this.loadingTitle}</h2>` : nothing}
      <div class="bc-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>`;
  }
}
const initBCLoadingIcon = () => {
  if (!window.customElements.get("bc-loading-icon")) {
    customElements.define("bc-loading-icon", BCLoadingIcon);
  }
};
export { initBCLoadingIcon };
